import curdGenerator from "./curdGenerator";

export const messaging = [
  {
    module: "Messaging",
    children: [
      {
        module: "Send",
        permission: "message.send",
        children: []
      },
      {
        module: "Inbox",
        permission: "message.inbox",
        children: []
      },
      {
        module: "Outbox",
        permission: "message.outbox",
        children: []
      },
      {
        module: "View",
        permission: "message.view",
        children: []
      },
      {
        module: "Delete",
        permission: "message.delete",
        children: []
      },
      {
        module: "Password Change",
        permission: "passwordchange",
        children: []
      },
      {
        module: "Company Change",
        permission: "companychange",
        children: []
      }
    ]
  }
];
